export default __webpack_public_path__ + "static/media/tcs1.80337cd9.jpeg";